import React from "react";
import { Box, Button, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./CopyLinkPopup.module.css";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSelector } from "react-redux";
import {
  resetPaymentLinkForRandomStatuses,
  resetPaymentLinkForSession,
  resetPaymentLinkStatus,
} from "../../pages/app/Nurture/service/nurtureSlice";
import { useDispatch } from "react-redux";

const CopyLinkPopupForRandom = (props: any) => {
  const { showCopyLinkPopup, onClose, setCopied, setComingFromRandomButton } =
    props;
  const dispatch = useDispatch();
  const { sendPaymentLinkUrl, sendPaymentLinkForSession } = useSelector(
    (state: any) => state.nurture,
  );
  const handleClose = () => {
    onClose();
    dispatch(resetPaymentLinkStatus());
    dispatch(resetPaymentLinkForRandomStatuses());
    dispatch(resetPaymentLinkForSession());
    setComingFromRandomButton(false);
  };

  const renderActionButton = () => {
    return (
      <CopyToClipboard
        text={
          sendPaymentLinkUrl?.data?.paymentLink
            ? sendPaymentLinkUrl?.data?.paymentLink
            : sendPaymentLinkForSession?.data?.paymentLink
        }
        onCopy={() => {
          setCopied(true);
          handleClose();
        }}
      >
        <Button variant="contained" sx={{ textTransform: "capitalize" }}>
          Copy Link
        </Button>
      </CopyToClipboard>
    );
  };

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "95%",
      sm: "50%",
      lg: 408,
      xl: 408,
      md: 408,
    },
    bgcolor: "background.paper",
    border: "none",
    boxShadow:
      "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    borderRadius: "12px",
    p: 3,
  };

  return (
    <Modal
      open={showCopyLinkPopup}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        zIndex: "999999",
        minWidth: "400px",
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "500px",
          maxHeight: "375px",
          minHeight: "185px",
          padding: "20px",
          borderRadius: "8px",
          boxShadow:
            "0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)",
          left: "5%",
          top: "8%",
          background: "#FFFFFF",
          overflow: "hidden",
          overflowY: "hidden",
        },
      }}
    >
      <Box sx={style}>
        <>
          <div className={styles.closeModalButton}>
            <CloseIcon onClick={handleClose} sx={{ color: "#667085" }} />
          </div>
          <div className={styles.modalTitle}>Share</div>

          <div>
            <div
              style={{
                color: "#142C44",
                fontFamily: "Poppins",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "22px",
                textTransform: "capitalize",
                marginBottom: "10px",
                marginTop: "20px",
              }}
            >
              Payment Link sent successfully
            </div>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                overflow: "auto",
                backgroundColor: "#f5f5f5",
                borderRadius: "4px",
                padding: "10px",
                fontFamily: "monospace",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                margin: "10px 0",
                fontSize: "12px",
              }}
            >
              {sendPaymentLinkUrl?.data?.paymentLink
                ? sendPaymentLinkUrl?.data?.paymentLink
                : sendPaymentLinkForSession?.data?.paymentLink}
            </Box>
          </div>
        </>

        <div
          className={styles.buttonSection}
          style={{
            marginBottom: "10px",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              color: "#BFBFBF",
              fontWeight: "500",
              lineHeight: "10px 24px 24px 24px",
              textTransform: "capitalize",
              borderRadius: "4px",
              border: "1px solid #BFBFBF",
              backgroundColor: "#FFF",
              "&:hover": {
                backgroundColor: "#FFF",
                border: "1px solid #BFBFBF",
              },
            }}
            onClick={handleClose}
          >
            Close
          </Button>
          {renderActionButton()}
        </div>
      </Box>
    </Modal>
  );
};
export default CopyLinkPopupForRandom;
